import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

const Terms: FC = () => {
  const { t } = useTranslation();

  return (
    <main className="overflow-y-auto px-4 pb-4 pt-[3.75rem] text-white/40">
      <h1 className="text-xl leading-none font-normal mb-4">
        {t('Terms of Use')}
      </h1>
      <ol className="w-full flex flex-col gap-4 p-0 m-0 text-sm font-norma list-inside !list-decimal">
        <li>
          <div className="inline-block">{t('Introduction')}</div>
          <div>
            {t(
              'Welcome to Star Industry ("Game", "Service"), an economic strategy game available through Telegram Mini Apps. By accessing and using the Game, you agree to these Terms of Use ("Terms"). If you do not agree, please do not use the Game.',
            )}
          </div>
        </li>
        <li>
          <div className="inline-block">{t('Access and Use')}</div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                'The Game is available only through Telegram Mini Apps and requires a valid Telegram account.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'You must be at least 18 years old (or older, depending on your local jurisdiction) to play.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'You agree to use the Game only for personal entertainment purposes and not for commercial activities.',
              )}
            </li>
          </ul>
        </li>
        <li>
          <div className="inline-block">{t('Virtual Currency and Items')}</div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                'The Game includes virtual currency (CASH, T-Gem) and virtual items, which have no real-world value.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'In-game assets cannot be exchanged for real money or transferred outside the Game.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'The developers reserve the right to modify or remove any virtual items at their discretion.',
              )}
            </li>
          </ul>
        </li>
        <li>
          <div className="inline-block">{t('Payments and Transactions')}</div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                'If the Game offers in-app purchases via Telegram Payments, all transactions are processed by Telegram Payment Providers.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'No refunds are provided for completed in-game purchases unless required by law.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'The Game does not store or process payment information; all transactions are handled by Telegram’s payment system.',
              )}
            </li>
          </ul>
        </li>
        <li>
          <div className="inline-block">{t('User Conduct')}</div>
          <div>{t('You agree NOT to:')}</div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                'Use bots, scripts, or automation to gain an unfair advantage.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'Exploit bugs or engage in cheating, fraud, or abuse of the Game mechanics.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'Engage in harassment, hate speech, or offensive behavior in chats.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'Attempt to sell, transfer, or trade in-game accounts or items.',
              )}
            </li>
          </ul>
        </li>
        <li>
          <div className="inline-block">
            {t('Data Collection and Privacy Policy')}
          </div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                'The Game may collect Telegram user ID, username, language settings, and other basic profile details as permitted by Telegram API.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'The Game does not collect or store personal financial data; all payments are processed through Telegram.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'The Game may use cookies or local storage for gameplay preferences.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'Your data is only used for providing the Game service and will not be sold or shared with third parties without consent.',
              )}
            </li>
            <li className="!list-disc">
              {t('For more information, please review our Privacy Policy.')}
            </li>
          </ul>
        </li>
        <li>
          <div className="inline-block">{t('Game Updates and Changes')}</div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                'The developers may update or modify the Game at any time, including adding or removing features.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'We may update these Terms, and continued use of the Game implies acceptance of any changes.',
              )}
            </li>
          </ul>
        </li>
        <li>
          <div className="inline-block">{t('Termination')}</div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                'The developers reserve the right to suspend or ban accounts that violate these Terms.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'No compensation is provided for accounts or in-game assets lost due to violations.',
              )}
            </li>
          </ul>
        </li>
        <li>
          <div className="inline-block">{t('Limitation of Liability')}</div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                'The Game is provided "AS IS," without warranties of any kind.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'The developers are not responsible for any losses, including lost progress, in-game assets, or data breaches.',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'To the maximum extent permitted by law, we disclaim liability for any indirect, incidental, or consequential damages.',
              )}
            </li>
          </ul>
        </li>
        <li>
          <div className="inline-block">
            {t('Governing Law and Jurisdiction')}
          </div>
          <ul className="w-full p-0 pl-5 m-0 !list-disc">
            <li className="!list-disc">
              {t(
                'These Terms shall be governed and interpreted in accordance with the laws of [Your Country].',
              )}
            </li>
            <li className="!list-disc">
              {t(
                'Any disputes arising out of or in connection with these Terms shall be resolved in the courts of [Your Country], unless otherwise required by applicable law.',
              )}
            </li>
          </ul>
        </li>
        <li>
          <div className="inline-block">{t('Contact Us')}</div>
        </li>
      </ol>
      <p className="text-sm mb-4">
        {t(
          'If you have any questions, contact us via Telegram @starindustryadmin or email: ',
        )}
      </p>
      <p className="text-sm mb-4">
        {t(
          'By playing Star Industry, you acknowledge that you have read, understood, and agreed to these Terms of Use.',
        )}
      </p>
    </main>
  );
};

export { Terms };
